import React from 'react'

const logo = require('../assets/dan-logo.png')

export default () => (
  <div>
    <div className="head">
      <div className="container">
        <img src={logo} alt="DAN EV - Dienst am Nächsten" className="logo" />
        <span
          id="global-slogan"
          data-editable="simpletext"
          className="slogan"
          data-global="data-global"
        >
          Nachbarschaftshilfe
          <br />
          von Mensch zu Mensch
        </span>
        <div className="hotline">
          <strong
            id="global-fragen"
            data-editable="simpletext"
            data-global="data-global"
          >
            Sie haben Fragen?
          </strong>
          <br />
          <span
            id="global-phone"
            data-editable="simpletext"
            data-global="data-global"
          >
            0174/3444893
            <br />
          </span>
        </div>
      </div>
    </div>
    <div className="nav">
      <div className="container">
        <ul className="clearfix">
          <li>
            <a href="/home">Startseite</a>
          </li>
          <li>
            <a href="/geschichte">Über Uns</a>
          </li>
          <li className="active">
            <a href="/dienstleistungen" className="active">
              Dienstleistungen
            </a>
          </li>
          <li>
            <a href="/sie-wollen-helfen">Sie wollen helfen?</a>
          </li>
          <li>
            <a href="/mitglieder">Mitglieder</a>
          </li>
          <li>
            <a href="/kontakt">Kontakt</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="content">
      <div className="container">
        <h1 id="headline" data-editable="simpletext" className="mb1">
          Dienstleistungsangebote
        </h1>
        <p id="subheadline" data-editable="simpletext">
          <span>
            Wir stärken und unterstützen Sie in Ihrem Alltag zu Hause.&nbsp;
          </span>
        </p>
        <hr />
        <p id="content" data-editable="text">
          <strong>
            <em>Im Haushalt:&nbsp;</em>
          </strong>
          <br /> Einkaufen, Essen zubereiten, Wäscheversorgung.....&nbsp;
          <br />
          <br />
          <strong>
            <em>Bei einfachen Pflegearbeiten:&nbsp;</em>
          </strong>
          <br /> Entlastung pflegender Angehöriger, Aufstehen und Ankleiden,
          Unterstützung der Pflegedienste....
          <br />
          <br />
          <strong>
            <em>Im sozialen Bereich:</em>
          </strong>
          <br /> Besuchs- und Fahrdienste, Begleitung zum Arzt oder
          Veranstaltungen sowie Behördengänge....
          <br />
          <br />
          <strong>
            <em>Kinder- und Familienhilfe:&nbsp;</em>
          </strong>
          <br /> Betreuung von Kindern, Unterstützung der Eltern.....&nbsp;
          <br />
          <br />
          <strong>
            <em>Beratung:</em>
          </strong>
          <br /> Vermittlung von Hilfsangeboten, Ausfüllen von Anträgen und
          Formularen.....&nbsp;
          <br />
          <br />
          <strong>
            <em>Hilfe rund ums Haus:</em>
          </strong>
          <br /> Wir helfen bei kleineren Problemen.....&nbsp;
          <br />
          <br />
          <strong>
            <em>Gespräche:</em>
          </strong>
          &nbsp;
          <br /> Wir nehmen uns Zeit für Sie und hören Ihnen zu.&nbsp;
        </p>
        <hr />
        <p id="ending" data-editable="text">
          Wir helfen da, wo Hilfe gebraucht wird: schnell, unkompliziert,
          bedarfsgerecht und bezahlbar.
          <br />
          <br />
          Durch die Übernahme der Trägerschaft der Nachbarschaftshilfe Dienst am
          Nächsten werden diese Angebote seit 1. Januar 2020 von der
          Keppler-Stiftung, Katholische Sozialstation Ulm verantwortet.
          <br />
          <br /> Für Fragen stehen wir Ihnen gerne zur Seite
        </p>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/dienstleistungen.js